import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncCollaborationSidebarDropArea = Loadable({
  loader: () => import( /* webpackChunkName: "collaboration-sidebar-drop-area" */'./CollaborationSidebarDropArea').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncCollaborationSidebarDropArea;